/**
 * Ekya — product card image flip (up to 3 images on click)
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('ekya-premium')) return;

  function initFlipCards() {
    document.querySelectorAll('[data-ekya-flip-images]').forEach((gallery) => {
      if (gallery.dataset.ekyaFlipReady) return;
      gallery.dataset.ekyaFlipReady = 'true';

      const images = gallery.dataset.ekyaFlipImages.split('|').filter(Boolean);
      if (images.length < 2) return;

      let index = 0;
      const mainImg = gallery.querySelector('.card-gallery img, .ekya-flip-card__img');
      if (!mainImg) return;

      gallery.classList.add('ekya-flip-card');
      gallery.setAttribute('role', 'button');
      gallery.setAttribute('tabindex', '0');
      gallery.setAttribute('aria-label', 'Click to see more product images');

      const flip = (event) => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();

        gallery.classList.add('is-flipping');
        index = (index + 1) % images.length;

        window.setTimeout(() => {
          mainImg.src = images[index];
          mainImg.srcset = '';
          gallery.classList.remove('is-flipping');
        }, 180);
      };

      gallery.addEventListener('click', flip);
      gallery.addEventListener('keydown', flip);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlipCards);
  } else {
    initFlipCards();
  }

  document.addEventListener('shopify:section:load', initFlipCards);
})();
